import { jsx, jsxs } from "react/jsx-runtime";
import { Avatar, Row, Col, Card, Divider, Space } from "antd";
import { UserOutlined } from "@ant-design/icons";
import { useOutletContext } from "@umijs/max";
import { getT } from "../../../../_utils/intl";
import companyAvatar from "../../assets/companyAvatar";
import { getLogo } from "../../../../utils/logo";
import useStyles from "./style";
const SelectCompany = ({
  appName,
  backgroundImage,
  companyList,
  userInfo,
  onQuit,
  onSelectCompany,
  renderExtraCompanyInfo,
  companyFieldNames = {
    id: "id",
    name: "name"
  }
}) => {
  const { styles } = useStyles({ backgroundImage });
  const t = getT();
  const { title, logo } = useOutletContext();
  const handleLogout = () => {
    onQuit([]);
  };
  const handleClick = (company) => {
    onSelectCompany(company);
  };
  return /* @__PURE__ */ jsxs("div", { className: styles.selectCompanyBg, children: [
    /* @__PURE__ */ jsxs("div", { className: styles.header, children: [
      /* @__PURE__ */ jsxs("div", { className: styles.headerLeft, children: [
        /* @__PURE__ */ jsx("img", { src: logo || getLogo(), className: styles.starLogo }),
        /* @__PURE__ */ jsx(Divider, { type: "vertical" }),
        /* @__PURE__ */ jsx("div", { className: styles.system, children: appName || title })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: styles.headerRight, children: [
        /* @__PURE__ */ jsx(Avatar, { size: 40, icon: /* @__PURE__ */ jsx(UserOutlined, {}) }),
        /* @__PURE__ */ jsxs("div", { className: styles.user, children: [
          /* @__PURE__ */ jsx("div", { children: userInfo == null ? void 0 : userInfo.userName }),
          /* @__PURE__ */ jsxs(Space, { children: [
            /* @__PURE__ */ jsx("span", { children: (userInfo == null ? void 0 : userInfo.phone) || (userInfo == null ? void 0 : userInfo.account) }),
            /* @__PURE__ */ jsx("a", { onClick: handleLogout, children: t("login.btn.logout") })
          ] })
        ] })
      ] })
    ] }),
    /* @__PURE__ */ jsx("div", { className: styles.selectCompany, children: /* @__PURE__ */ jsx("div", { className: styles.selectCompanyList, children: /* @__PURE__ */ jsx(Row, { gutter: [16, 16], children: companyList.map((item) => /* @__PURE__ */ jsx(Col, { span: 8, children: /* @__PURE__ */ jsx("a", { onClick: () => handleClick(item), children: /* @__PURE__ */ jsx(Card, { children: /* @__PURE__ */ jsxs("div", { className: styles.companyCard, children: [
      /* @__PURE__ */ jsx(Avatar, { size: 40, src: companyAvatar }),
      /* @__PURE__ */ jsxs("div", { className: styles.companyContent, children: [
        /* @__PURE__ */ jsx("div", { children: item[companyFieldNames.name] }),
        renderExtraCompanyInfo ? renderExtraCompanyInfo(item) : null
      ] })
    ] }) }) }) }, item[companyFieldNames.id])) }) }) })
  ] });
};
var SelectCompany_default = SelectCompany;
export {
  SelectCompany_default as default
};
